import clsx from 'clsx';
import React from 'react';

/**
 * Badge - Genel amaçlı etiket/durum bileşeni
 * 
 * @param {string} children - İçerik
 * @param {string} variant - Renk/Stil (primary, success, warning, error, info, neutral)
 * @param {string} size - Boyut (sm, md, lg)
 * @param {string} className - Ek stiller
 */
export default function Badge({
    children,
    variant = 'neutral',
    size = 'md',
    className,
    ...props
}) {
    const variants = {
        primary: 'bg-primary/10 text-primary border-primary/20',
        success: 'bg-success/10 text-success border-success/20',
        warning: 'bg-warning/10 text-warning border-warning/20',
        error: 'bg-error/10 text-error border-error/20',
        info: 'bg-info/10 text-info border-info/20',
        neutral: 'bg-bg-tertiary text-text-secondary border-border-light',
        outline: 'bg-transparent border-border-light text-text-secondary',
    };

    const sizes = {
        sm: 'text-xs px-2 py-0.5',
        md: 'text-xs px-2.5 py-1',
        lg: 'text-sm px-3 py-1.5',
    };

    return (
        <span
            className={clsx(
                'inline-flex items-center justify-center font-medium rounded-full border',
                variants[variant] || variants.neutral,
                sizes[size] || sizes.md,
                className
            )}
            {...props}
        >
            {children}
        </span>
    );
}
